<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div v-if="userData.permissions['view_perm'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-sm border-0">
            <div class="card-body p-4">
              <!-- Filter Bar -->
              <div class="permission-header mb-4">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <div class="input-group">
                      <span class="input-group-text bg-light border-end-0">
                        <i class="mdi mdi-magnify"></i>
                      </span>
                      <input
                        type="text"
                        class="form-control border-start-0 ps-0"
                        placeholder="Search for roles..."
                        v-model="searchQuery"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 text-end">
                    <span class="badge bg-soft-primary text-primary px-3 py-2">
                      <i class="mdi mdi-account-group me-1"></i>
                      {{ permissions.length }} Roles
                    </span>
                  </div>
                </div>
              </div>

              <div class="permission-tabs-wrapper">
                <div class="permission-tabs-container">
                  <div
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="['permission-tab', { active: activeTab === index }]"
                    @click="activeTab = index"
                  >
                    <i :class="tab.icon"></i>
                    <span>{{ tab.title }}</span>
                  </div>
                </div>
              </div>

              <div class="tab-content-wrapper">
                <transition name="fade" mode="out-in">
                  <div :key="activeTab" class="permission-table-container">
                    <!-- Modules Tab -->
                    <div v-if="activeTab === 0">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Roles
                              </th>
                              <th>
                                <i class="mdi mdi-view-dashboard"></i
                                ><br />Dashboard
                              </th>
                              <th>
                                <i class="mdi mdi-school"></i><br />Students
                              </th>
                              <th>
                                <i class="mdi mdi-cash-multiple"></i
                                ><br />Finance
                              </th>
                              <th>
                                <i class="mdi mdi-clipboard-text"></i
                                >Marks<br />Assessments
                              </th>
                              <th>
                                <i class="mdi mdi-wallet"></i><br />Expenses
                              </th>
                              <th>
                                <i class="mdi mdi-medical-bag"></i><br />SickBay
                              </th>
                              <th>
                                <i class="mdi mdi-book-open-page-variant"></i
                                ><br />Library
                              </th>
                              <th><i class="mdi mdi-food"></i><br />Cafe</th>
                              <th>
                                <i class="mdi mdi-calendar-check"></i
                                ><br />Attendance
                              </th>
                              <!-- <th>
                                  <i class="mdi mdi-account-tie"></i
                                  >Human<br />Resource
                                </th> -->
                              <th><i class="mdi mdi-store"></i><br />Store</th>
                              <!-- <th>
                                  <i class="mdi mdi-file-document"></i><br />Reqs
                                </th> -->
                              <th><i class="mdi mdi-cog"></i><br />Settings</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_dashboard == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_dashboard',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_students == 1"
                                  @change="
                                    changePermission(item.role, 'view_students')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_finance == 1"
                                  @change="
                                    changePermission(item.role, 'view_finance')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_marks_entry == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_marks_entry',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_expenses == 1"
                                  @change="
                                    changePermission(item.role, 'view_expenses')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_sickbay == 1"
                                  @change="
                                    changePermission(item.role, 'view_sickbay')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.visit_library == 1"
                                  @change="
                                    changePermission(item.role, 'visit_library')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_canteen == 1"
                                  @change="
                                    changePermission(item.role, 'view_canteen')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_attendance == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_attendance',
                                    )
                                  "
                                />
                              </td>
                              <!-- <td>
                                  <RockerSwitch
                                    :value="item.view_hr == 1"
                                    @change="
                                      changePermission(item.role, 'view_hr')
                                    "
                                  />
                                </td> -->
                              <td>
                                <RockerSwitch
                                  :value="item.view_inventory == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_inventory',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_settings == 1"
                                  @change="
                                    changePermission(item.role, 'view_settings')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Students Tab -->
                    <div v-if="activeTab === 1">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-account-plus"></i>Add &
                                Manage<br />
                                Student
                              </th>
                              <th>
                                <i class="mdi mdi-account-supervisor"></i
                                ><br />View Students
                              </th>
                              <th>
                                <i class="mdi mdi-account-supervisor"></i
                                ><br />View Parents
                              </th>
                              <th>
                                <i class="mdi mdi-file-chart"></i><br />View
                                Enrollments
                              </th>
                              <th>
                                <i class="mdi mdi-account-arrow-right"></i
                                ><br />Migrate Students
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.new_student == 1"
                                  @change="
                                    changePermission(item.role, 'new_student')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_students == 1"
                                  @change="
                                    changePermission(item.role, 'view_student')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_parents == 1"
                                  @change="
                                    changePermission(item.role, 'view_parents')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_enrollements == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_enrollments',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.migrate == 1"
                                  @change="
                                    changePermission(item.role, 'migrate')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Finance Tab -->
                    <div v-if="activeTab === 2">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-cash-plus"></i>Add & Manage<br />
                                Fees Payments
                              </th>
                              <th>
                                <i class="mdi mdi-eye"></i>View<br />
                                Payments
                              </th>
                              <th>
                                <i class="mdi mdi-cash-multiple"></i
                                >Optional<br />
                                Fees
                              </th>
                              <th>
                                <i class="mdi mdi-school"></i>View Bursaries,
                                Exemptions<br />
                                & Balances
                              </th>
                              <th>
                                <i class="mdi mdi-printer"></i>Print<br />
                                Receipts
                              </th>
                              <th>
                                <i class="mdi mdi-printer"></i>Pocket<br />
                                Money
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.add_fees_payment == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'add_fees_payment',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_fees_payment == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_fees_payment',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.optional_fees_payments == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'optional_fees_payments',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.student_bursary == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'student_bursary',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.print_receipts == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'print_receipts',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_pm == 1"
                                  @change="
                                    changePermission(item.role, 'view_pm')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Marks Entry Tab -->
                    <div v-if="activeTab === 3">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-eye"></i>View Nursery
                                <br />Section
                              </th>
                              <th>
                                <i class="mdi mdi-eye"></i>View Primary
                                <br />Section
                              </th>
                              <th>
                                <i class="mdi mdi-plus-circle"></i>Add & View<br />
                                Marks
                              </th>
                              <th>
                                <i class="mdi mdi-file-document"></i>View &
                                Print<br />
                                Report Cards
                              </th>
                              <th>
                                <i class="mdi mdi-clipboard-list"></i>Manage
                                Exams <br />& Gradings
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_nursery == 1"
                                  @change="
                                    changePermission(item.role, 'view_alevel')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_primary == 1"
                                  @change="
                                    changePermission(item.role, 'view_olevel')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.add_marks_entry == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'add_marks_entry',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.report_cards == 1"
                                  @change="
                                    changePermission(item.role, 'report_cards')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.exam_sets == 1"
                                  @change="
                                    changePermission(item.role, 'exam_sets')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Expenses Tab -->
                    <div v-if="activeTab === 4">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-file-plus"></i><br />Record
                                Expenses
                              </th>
                              <th>
                                <i class="mdi mdi-pencil"></i>Edit & View<br />
                                Expense Records
                              </th>
                              <th>
                                <i class="mdi mdi-format-list-bulleted"></i
                                ><br />Expense Items
                              </th>
                              <th>
                                <i class="mdi mdi-folder-multiple"></i
                                ><br />Categories
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.record_expenses == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'record_expenses',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.edit_expenses == 1"
                                  @change="
                                    changePermission(item.role, 'edit_expenses')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.expense_items == 1"
                                  @change="
                                    changePermission(item.role, 'expense_items')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.expense_categories == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'expense_categories',
                                    )
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- SickBay Tab -->
                    <div v-if="activeTab === 5">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-plus-circle"></i><br />Add
                                Visit
                              </th>
                              <th>
                                <i class="mdi mdi-eye"></i><br />View Visits
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.add_sickbay_visit == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'add_sickbay_visit',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_sickbay_visit == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_sickbay_visit',
                                    )
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Library Tab -->
                    <div v-if="activeTab === 6">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-book-check"></i><br />Books
                                Borrowed
                              </th>
                              <th>
                                <i class="mdi mdi-book-multiple"></i
                                ><br />Library Books
                              </th>
                              <th>
                                <i class="mdi mdi-tag-multiple"></i
                                ><br />Categories
                              </th>
                              <th>
                                <i class="mdi mdi-store"></i><br />Book Store
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.books_borrowed == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'books_borrowed',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.library_books == 1"
                                  @change="
                                    changePermission(item.role, 'library_books')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.book_categories == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'book_categories',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.book_store == 1"
                                  @change="
                                    changePermission(item.role, 'book_store')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Pocket Money Tab 
                      <div v-if="activeTab === 7">
                        <div class="table-responsive modern-table">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th class="role-column sticky-column">
                                  <i class="mdi mdi-account-badge me-2"></i>Role
                                  Name
                                </th>
                                <th>
                                  <i class="mdi mdi-cash"></i><br />Pocket Money
                                </th>
                                <th>
                                  <i class="mdi mdi-piggy-bank"></i><br />Savings
                                </th>
                                <th>
                                  <i class="mdi mdi-cash-minus"></i
                                  ><br />Withdraws
                                </th>
                                <th>
                                  <i class="mdi mdi-wallet"></i><br />PM Balances
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in filteredPermissions"
                                :key="item.id"
                                class="permission-row"
                              >
                                <td class="role-column sticky-column">
                                  <div class="role-badge">
                                    <i class="mdi mdi-shield-account"></i>
                                    {{ item.rolename }}
                                  </div>
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_pocketmoney == 1"
                                    @change="
                                      changePermission(
                                        item.role,
                                        'view_pocketmoney',
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_savings == 1"
                                    @change="
                                      changePermission(item.role, 'view_savings')
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_withdraws == 1"
                                    @change="
                                      changePermission(
                                        item.role,
                                        'view_withdraws',
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_balances == 1"
                                    @change="
                                      changePermission(item.role, 'view_balances')
                                    "
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>-->

                    <!-- Canteen Tab -->
                    <div v-if="activeTab === 7">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-plus"></i><br />Add Canteen
                              </th>
                              <th>
                                <i class="mdi mdi-account-multiple"></i><br />
                                Canteen Users
                              </th>
                              <th>
                                <i class="mdi mdi-food-variant"></i
                                ><br />Products
                              </th>
                              <th>
                                <i class="mdi mdi-point-of-sale"></i><br />Sales
                                Point
                              </th>
                              <th>
                                <i class="mdi mdi-receipt"></i><br />Invoices
                              </th>
                              <th>
                                <i class="mdi mdi-printer"></i><br />Print
                                Invoices
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.add_canteen == 1"
                                  @change="
                                    changePermission(item.role, 'add_canteen')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.add_canteen_users == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'add_canteen_users',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_products == 1"
                                  @change="
                                    changePermission(item.role, 'view_products')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_salespoint == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_salespoint',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_salesinvoice == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_salesinvoice',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.print_invoice == 1"
                                  @change="
                                    changePermission(item.role, 'print_invoice')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Attendance Tab -->
                    <div v-if="activeTab === 8">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-account-tie"></i><br />Staff
                                Attendance
                              </th>
                              <th>
                                <i class="mdi mdi-school"></i><br />Student
                                Attendance
                              </th>
                              <th>
                                <i class="mdi mdi-calendar-clock"></i
                                ><br />Timesheets
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_staff_attendance == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_staff_attendance',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_student_attendance == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_student_attendance',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_timesheets == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_timesheets',
                                    )
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Human Resource Tab 
                      <div v-if="activeTab === 10">
                        <div class="table-responsive modern-table">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th class="role-column sticky-column">
                                  <i class="mdi mdi-account-badge me-2"></i>Role
                                  Name
                                </th>
                                <th>
                                  <i class="mdi mdi-account-plus"></i><br />Add
                                  Staff
                                </th>
                                <th>
                                  <i class="mdi mdi-shield-star"></i><br />Roles &
                                  Positions
                                </th>
                                <th>
                                  <i class="mdi mdi-cash-multiple"></i
                                  ><br />Salary Details
                                </th>
                                <th>
                                  <i class="mdi mdi-wallet-plus"></i
                                  ><br />Allowances
                                </th>
                                <th>
                                  <i class="mdi mdi-calendar-remove"></i
                                  ><br />Staff Leave
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in filteredPermissions"
                                :key="item.id"
                                class="permission-row"
                              >
                                <td class="role-column sticky-column">
                                  <div class="role-badge">
                                    <i class="mdi mdi-shield-account"></i>
                                    {{ item.rolename }}
                                  </div>
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.add_staff == 1"
                                    @change="
                                      changePermission(item.role, 'add_staff')
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.add_roles == 1"
                                    @change="
                                      changePermission(item.role, 'add_roles')
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_salary_details == 1"
                                    @change="
                                      changePermission(
                                        item.role,
                                        'view_salary_details',
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_allowances == 1"
                                    @change="
                                      changePermission(
                                        item.role,
                                        'view_allowances',
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <RockerSwitch
                                    :value="item.view_staff_leaves == 1"
                                    @change="
                                      changePermission(
                                        item.role,
                                        'view_staff_leaves',
                                      )
                                    "
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>-->

                    <!-- Stores Tab -->
                    <div v-if="activeTab === 9">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-school"></i><br />View
                                Inventory
                              </th>
                              <th>
                                <i class="mdi mdi-account-group"></i
                                ><br />Requirements Section
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_inventory == 1"
                                  @change="
                                    changePermission(
                                      item.role,
                                      'view_inventory',
                                    )
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.requirements == 1"
                                  @change="
                                    changePermission(item.role, 'requirements')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Settings Tab -->
                    <div v-if="activeTab === 10">
                      <div class="table-responsive modern-table">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="role-column sticky-column">
                                <i class="mdi mdi-account-badge me-2"></i>Role
                                Name
                              </th>
                              <th>
                                <i class="mdi mdi-school"></i>School<br />
                                Management
                              </th>
                              <th>
                                <i class="mdi mdi-google-classroom"></i
                                >Class<br />
                                Management
                              </th>
                              <th>
                                <i class="mdi mdi-account-group"></i>Staff<br />
                                Management
                              </th>
                              <th>
                                <i class="mdi mdi-account-settings"></i>HR
                                <br />Management
                              </th>
                              <th>
                                <i class="mdi mdi-monitor-dashboard"></i
                                >Other<br />
                                Features
                              </th>
                              <th>
                                <i class="mdi mdi-chart-bar"></i>View<br />
                                Reports
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              v-for="item in filteredPermissions"
                              :key="item.id"
                              class="permission-row"
                            >
                              <td class="role-column sticky-column">
                                <div class="role-badge">
                                  <i class="mdi mdi-shield-account"></i>
                                  {{ item.rolename }}
                                </div>
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.school_mgt == 1"
                                  @change="
                                    changePermission(item.role, 'school_mgt')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.class_mgt == 1"
                                  @change="
                                    changePermission(item.role, 'class_mgt')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.staff_mgt == 1"
                                  @change="
                                    changePermission(item.role, 'staff_mgt')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_hr == 1"
                                  @change="
                                    changePermission(item.role, 'view_hr')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.others == 1"
                                  @change="
                                    changePermission(item.role, 'others')
                                  "
                                />
                              </td>
                              <td>
                                <RockerSwitch
                                  :value="item.view_reports == 1"
                                  @change="
                                    changePermission(item.role, 'view_reports')
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Permission State -->
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div class="text-center">
            <h4 class="text-primary mb-4">
              You have no permission to view the System Permissions Page...
            </h4>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";

import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { permissionComputed, permissionMethods } from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    RockerSwitch,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "System Permissions", active: true },
      ],
      isBusy: true,
      role: "",
      permission: "",
      activeTab: 0,
      searchQuery: "",
      tabs: [
        { title: "Modules", icon: "mdi mdi-view-grid" },
        { title: "Students", icon: "mdi mdi-school" },
        { title: "Finance", icon: "mdi mdi-cash-multiple" },
        { title: "Marks Entry", icon: "mdi mdi-clipboard-text" },
        { title: "Expenses", icon: "mdi mdi-wallet" },
        { title: "SickBay", icon: "mdi mdi-medical-bag" },
        { title: "Library", icon: "mdi mdi-book-open-page-variant" },
        // { title: "Pocket Money", icon: "mdi mdi-currency-usd" },
        { title: "Canteen", icon: "mdi mdi-food" },
        { title: "Attendance", icon: "mdi mdi-calendar-check" },
        // { title: "Human Resource", icon: "mdi mdi-account-tie" },
        { title: "Store", icon: "mdi mdi-store" },
        { title: "Settings", icon: "mdi mdi-cog" },
      ],
    };
  },
  computed: {
    ...permissionComputed,
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.permissions.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.permissions.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    filteredPermissions() {
      if (!this.searchQuery) {
        return this.permissions;
      }
      const query = this.searchQuery.toLowerCase();
      return this.permissions.filter((item) =>
        item.rolename.toLowerCase().includes(query),
      );
    },
  },
  mounted() {
    this.fetchPermissions();
    this.isBusy = false;
  },
  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>

<style scoped>
/* Permission Header */
.permission-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
}

.input-group-text {
  background: transparent;
  border: 1px solid #e3e6ef;
}

.form-control:focus {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.15);
}

.badge.bg-soft-primary {
  background-color: rgba(var(--bs-primary-rgb), 0.1) !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
}

/* Modern Tab Navigation */
.permission-tabs-wrapper {
  margin-bottom: 32px;
  border-bottom: 2px solid #e3e6ef;
}

.permission-tabs-container {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f7fafc;
}

.permission-tabs-container::-webkit-scrollbar {
  height: 6px;
}

.permission-tabs-container::-webkit-scrollbar-track {
  background: #f7fafc;
  border-radius: 3px;
}

.permission-tabs-container::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.permission-tabs-container::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.permission-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #ffffff;
  border: 2px solid #e3e6ef;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-weight: 500;
  color: #6c757d;
  position: relative;
  border-bottom: none;
}

.permission-tab i {
  font-size: 18px;
}

.permission-tab span:first-of-type {
  font-size: 14px;
}

.permission-tab:hover {
  background: #f8f9fa;
  border-color: #dc3545;
  transform: translateY(-2px);
}

.permission-tab.active {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.permission-tab.active i {
  color: white;
}

/* Tab Content */
.tab-content-wrapper {
  padding: 24px 0;
}

.permission-table-container {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Modern Table Styling */
.modern-table {
  background: white;
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.modern-table table {
  margin-bottom: 0;
  min-width: 100%;
}

.modern-table thead {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

.modern-table thead th {
  padding: 18px 16px;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  border: none;
  vertical-align: middle;
  white-space: nowrap;
}

.modern-table thead th i {
  font-size: 20px;
  display: block;
  margin-bottom: 4px;
}

.modern-table tbody td {
  padding: 16px;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #f0f0f0;
  color: #495057;
}

.modern-table tbody tr {
  transition: all 0.2s ease;
}

.modern-table tbody tr:hover {
  background: #fff5f5;
}

.modern-table tbody tr:last-child td {
  border-bottom: none;
}

/* Sticky Role Column */
.sticky-column {
  position: sticky;
  left: 0;
  z-index: 10;
  background: white;
}

.modern-table thead .sticky-column {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  z-index: 11;
}

.modern-table tbody tr:hover .sticky-column {
  background: #fff5f5;
}

.role-column {
  min-width: 150px;
  text-align: left !important;
}

/* .role-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
      border-radius: 8px;
      font-weight: 600;
      color: var(--bs-primary);
      font-size: 14px;
      white-space: nowrap;
    } */

.role-badge i {
  font-size: 12px;
}

/* Card Styling */
.card {
  border-radius: 16px;
  overflow: hidden;
}

.card-body {
  padding: 32px;
}

/* Responsive */
@media (max-width: 768px) {
  .permission-header .row > div {
    margin-bottom: 12px;
  }

  .permission-tab {
    padding: 10px 16px;
    font-size: 13px;
  }

  .permission-tab i {
    font-size: 16px;
  }

  .card-body {
    padding: 20px;
  }

  .role-column {
    min-width: 100px;
  }

  /* .role-badge {
        padding: 6px 12px;
        font-size: 12px;
      } */
}

/* Additional utility classes */
.text-primary {
  color: var(--bs-primary) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.border-0 {
  border: 0 !important;
}
</style>
